const passwordElement = document.getElementById("new-password");

if (passwordElement !== null) {
  const password = new CustomFormValidation(passwordElement, passwordElement.nextElementSibling);

  function disableSubmit() {
    if (!allValid()) {
      submitBtn.setAttribute("disabled", true);
    } else {
      submitBtn.removeAttribute("disabled");
    }
  }

  function runCheck(event) {
    let e = event.target;
    if (e.id === "new-password") {
      passwordCheck(password);
    }
  }

  function allValid() {
    return password.getValid;
  }

  let submitBtn = document.getElementById("submit");

  disableSubmit();

  document.addEventListener("input", (event) => {
    runCheck(event);
  }, true);

  document.addEventListener("blur", (event) => {
    runCheck(event);
  }, true);

  document.addEventListener("keyup", disableSubmit, true);
}

let passwordReset = document.querySelector(".password-reset-form");
passwordReset.addEventListener("submit", (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);
  let options = {
    method: "POST",
    body: formData,
  };
  fetch(passwordReset.action, options).then((response) => {
    return response.json();
  }).then((text) => {
    if (text.validation === false) {
      document.getElementById("something-went-wrong").classList.add("alert-msg--show");
    } else if (text.emailSent) {
      let getUrl = window.location;
      passwordReset.reset();
      window.location.replace(getUrl.protocol + "//" + getUrl.host + "?message=3");
    } else {
      let getUrl = window.location;
      passwordReset.reset();
      window.location.replace(getUrl.protocol + "//" + getUrl.host + "?message=4");
    }

  }).catch((error) => {
    console.error(error);
  })
});